// Mock data para o site IE Eneagrama

export const heroData = {
  title: ["TRANSFORME", "VIDAS."],
  subtitle: "Líder em Eneagrama no Brasil. 26 anos transformando pessoas e empresas através do autoconhecimento.",
  cta: "Conheça o IE",
  stats: [
    { label: "Anos de Atuação", value: "15+" },
    { label: "Empresas Atendidas", value: "3.000+" },
    { label: "Eneagramados", value: "70.000+" },
    { label: "Unidades no Brasil", value: "41" }
  ]
};

export const aboutData = {
  title: "Conheça o IE",
  subtitle: "Pioneiros em Eneagrama no Brasil",
  description: "O Instituto Eneagrama é referência em desenvolvimento humano e organizacional através do Eneagrama. Com 15 anos de experiência, oferecemos programas transformadores para indivíduos e empresas.",
  values: [
    { title: "Excelência", description: "Compromisso com a qualidade em cada programa" },
    { title: "Transformação", description: "Resultados concretos e duradouros" },
    { title: "Inovação", description: "Metodologias atualizadas e eficazes" },
    { title: "Ética", description: "Respeito e integridade em todas as relações" }
  ]
};

export const solutionsData = {
  individual: [
    {
      id: "e-personalidade",
      title: "E-Personalidade",
      description: "Mapeamento e desenvolvimento comportamental via Eneagrama.",
      icon: "solar:user-circle-linear",
      details: "Mapeamento e desenvolvimento comportamental via Eneagrama. O programa diagnostica os padrões automáticos de personalidade e intervém diretamente na estrutura que gera o comportamento — com impacto em liderança, comunicação, tomada de decisão e performance de equipe. Formato extensivo (32h) ou intensivo (22h). Inclui 2 mentorias individuais e garantia de 5 anos."
    },
    {
      id: "e-corpo",
      title: "E-Corpo",
      description: "Leitura e intervenção em padrões corporais com base na Psicologia Reichiana.",
      icon: "solar:body-linear",
      details: "Leitura e intervenção em padrões corporais com base na Psicologia Reichiana. O que o comportamento verbal não revela, o corpo entrega. O programa desenvolve presença, autoridade e capacidade de resposta sob pressão — decodificando os mecanismos de defesa registrados na estrutura física."
    },
    {
      id: "e-got",
      title: "E-GOT",
      description: "Simulação estratégica imersiva para alta liderança.",
      icon: "solar:medal-ribbons-star-linear",
      details: "Simulação estratégica imersiva para alta liderança. Dispositivo de aprendizagem vivencial que expõe os líderes a cenários de poder, conflito, alianças e escassez de recursos — revelando em tempo real como seus padrões de comportamento operam sob pressão extrema. Turmas exclusivas de 12 a 30 líderes."
    }
  ],
  corporate: [
    {
      id: "e-processual",
      title: "E-Processual",
      description: "Eneagrama aplicado à gestão de projetos e ciclos organizacionais.",
      icon: "solar:graph-up-linear",
      details: "Eneagrama aplicado à gestão de projetos e ciclos organizacionais. O programa une diagnóstico comportamental à estrutura dos 9 pontos para conduzir projetos com previsibilidade e intencionalidade — eliminando os padrões automáticos que sabotam cronogramas, entregas e alinhamento de equipe."
    },
    {
      id: "e-vendas",
      title: "E-Vendas",
      description: "Engenharia comportamental aplicada ao processo comercial.",
      icon: "solar:chart-linear",
      details: "Engenharia comportamental aplicada ao processo comercial. O programa usa o mapeamento de personalidades para acelerar confiança, adaptar comunicação e elevar conversão em vendas consultivas e high-ticket. 9 encontros de 4h ou 3 dias intensivos."
    }
  ]
};

export const testimonialsData = [
  {
    name: "Fernanda Raimundo",
    company: "Unilever",
    role: "RH",
    text: "Certificação de mais uma unidade da Unilever Brasil, Melhora no desempenho e na performance das equipes",
    video: "https://youtu.be/a4v9eLOcrJM",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/fernanda_raimundo-300x256.png"
  },
  {
    name: "Luiz Fernando",
    company: "Unimed - Vitória - ES",
    role: "",
    text: "Melhora no desempenho da liderança com a equipe que refletiu diretamente na qualidade dos serviços",
    video: "https://youtu.be/V9GNgFnpUEI",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/luiz_fernando-300x268.png"
  },
  {
    name: "Virna Dias",
    company: "Jogadora de Vôlei",
    role: "",
    text: "Com o Eneagrama comecei a entender melhor a mim mesmo e também entender as outras pessoas e seus gatilhos de estresse",
    video: "https://youtu.be/Psrp1fPeUo8",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/virna_dias-276x300.png"
  },
  {
    name: "Leonardo Fortolan",
    company: "FuelTech",
    role: "",
    text: "Com a aplicação do Eneagrama Processual economizamos centenas de milhares de reais alinhando processos e projetos.",
    video: "",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/fortolan_fueltech.jpg"
  }
];

export const faqData = [
  {
    question: "O Eneagrama é terapia?",
    answer: "Não. O Instituto Eneagrama opera como empresa de engenharia comportamental. Nosso método é uma tecnologia de diagnóstico e intervenção em padrões automáticos — não é terapia, coaching, autoajuda ou dinâmica de grupo."
  },
  {
    question: "Qual a diferença do IE para outros cursos de Eneagrama?",
    answer: "Metodologia patenteada, 15+ anos de aplicação rigorosa, 70.000+ eneagramados e NPS superior a 95%. Enquanto o mercado usa o Eneagrama para rotular personalidades, o IE intervém diretamente na estrutura que gera o comportamento."
  },
  {
    question: "O que é Eneagrama?",
    answer: "O Eneagrama é um sistema de estudo da personalidade que identifica nove tipos de personalidade distintos, cada um com seus próprios padrões de pensamento, sentimento e comportamento. É uma ferramenta poderosa para autoconhecimento e desenvolvimento pessoal."
  },
  {
    question: "Como funciona o programa E-Personalidade?",
    answer: "O E-Personalidade é um programa completo que ajuda você a descobrir seu tipo de personalidade no Eneagrama, compreender seus padrões de comportamento e desenvolver estratégias para seu crescimento pessoal e profissional."
  },
  {
    question: "Qual a duração dos cursos?",
    answer: "A duração varia conforme o programa escolhido. Os cursos individuais geralmente têm duração de 16 a 24 horas, distribuídas em módulos. Programas corporativos são customizados conforme as necessidades da empresa."
  },
  {
    question: "O IE oferece certificação?",
    answer: "Sim, oferecemos programas de certificação para profissionais que desejam se tornar facilitadores de Eneagrama. A certificação é reconhecida nacionalmente e segue padrões internacionais."
  },
  {
    question: "Como funciona a franquia do IE?",
    answer: "A franquia IE oferece um modelo de negócio completo com suporte em metodologia, marketing, gestão e operação. O franqueado recebe treinamento completo e acesso a todos os programas do instituto."
  }
];

export const teamData = [
  {
    name: "Rodrigo Amarante",
    role: "CEO",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/02/rodrigo_amarante-1-300x298.png"
  },
  {
    name: "Heloisa Labres",
    role: "Diretora de Instrução",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/heloisa_labres-300x300.png"
  },
  {
    name: "Daiany Franco",
    role: "Diretora Comercial",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/daiany-300x300.png"
  },
  {
    name: "Luciano Iepsen",
    role: "Franqueado Região dos Vales RS",
    image: "https://ieneagrama.com.br/wp-content/uploads/2019/10/Luciano-Iepsen-Google-Chrome-291x300.jpg"
  },
  {
    name: "Magali Felix",
    role: "Franqueada Noroeste do RS",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/magali-300x300.png"
  },
  {
    name: "Dirceu Hoepers",
    role: "Franqueado Sul Catarinense",
    image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/dirceu-300x300.png"
  }
];

export const franchisesData = {
  "Rio Grande do Sul": [
    { city: "Porto Alegre", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/porto_alegre.png", contact: "contato@ieportoalegre.com.br", instagram: "@ie_portoalegre" },
    { city: "Passo Fundo", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/passo_fundo.png", contact: "contato@iepassofundo.com.br", instagram: "@ie_passofundo" },
    { city: "Santa Rosa", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/santa_rosa.png", contact: "contato@iesantarosa.com.br", instagram: "@ie_santarosa" },
    { city: "Santa Cruz do Sul", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/santa_cruz_do_sul.png", contact: "contato@iesantacruz.com.br", instagram: "@ie_santacruz" },
    { city: "Lajeado", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/lajeado.png", contact: "contato@ielajeado.com.br", instagram: "@ie_lajeado" },
    { city: "Gramado", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/gramado.png", contact: "contato@iegramado.com.br", instagram: "@ie_gramado" },
    { city: "Bento Gonçalves", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/bento_gonalves.png", contact: "contato@iebento.com.br", instagram: "@ie_bento" },
    { city: "Estância Velha", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/estancia_velha.png", contact: "contato@ieestancia.com.br", instagram: "@ie_estancia" },
    { city: "Novo Hamburgo", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/novo_hamburgo.png", contact: "contato@ienovohamburgo.com.br", instagram: "@ie_novohamburgo" },
    { city: "Torres", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/torres.png", contact: "contato@ietorres.com.br", instagram: "@ie_torres" },
    { city: "Palmeira das Missões", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/palmeira_das_missoes.png", contact: "contato@iepalmeira.com.br", instagram: "@ie_palmeira" },
    { city: "Pelotas", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/pelotas.png", contact: "contato@iepelotas.com.br", instagram: "@ie_pelotas" },
    { city: "Parobé", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/parobe.png", contact: "contato@ieparobe.com.br", instagram: "@ie_parobe" }
  ],
  "Santa Catarina": [
    { city: "Florianópolis", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/florianopolis.png", contact: "contato@iefloripa.com.br", instagram: "@ie_floripa" },
    { city: "Chapecó", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/chapeco.png", contact: "contato@iechapeco.com.br", instagram: "@ie_chapeco" },
    { city: "Criciúma", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/criciuma.png", contact: "contato@iecriciuma.com.br", instagram: "@ie_criciuma" },
    { city: "Joinville", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/joinville.png", contact: "contato@iejoinville.com.br", instagram: "@ie_joinville" },
    { city: "Balneário Camboriu", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/balneario_camboriu.png", contact: "contato@iebalneario.com.br", instagram: "@ie_balneario" },
    { city: "Xanxerê", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/xanxere.png", contact: "contato@iexanxere.com.br", instagram: "@ie_xanxere" },
    { city: "São Miguel do Oeste", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/sao_miguel_do_oeste.png", contact: "contato@iesaomiguel.com.br", instagram: "@ie_saomiguel" },
    { city: "Mondaí", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/mondai.png", contact: "contato@iemondai.com.br", instagram: "@ie_mondai" },
    { city: "Iporã do Oeste", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/ipora_do_oeste.png", contact: "contato@ieipora.com.br", instagram: "@ie_ipora" }
  ],
  "Paraná": [
    { city: "Curitiba", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/curitiba.png", contact: "contato@iecuritiba.com.br", instagram: "@ie_curitiba" },
    { city: "Foz do Iguaçu", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/foz_do_iguacu.png", contact: "contato@iefoz.com.br", instagram: "@ie_foz" },
    { city: "Pato Branco", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/pato_branco.png", contact: "contato@iepatobranco.com.br", instagram: "@ie_patobranco" },
    { city: "Guarapuava", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/guarapuava.png", contact: "contato@ieguarapuava.com.br", instagram: "@ie_guarapuava" },
    { city: "Cascavel", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/cascavel.png", contact: "contato@iecascavel.com.br", instagram: "@ie_cascavel" },
    { city: "Maringá", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/maringa.png", contact: "contato@iemaringa.com.br", instagram: "@ie_maringa" }
  ],
  "São Paulo": [
    { city: "Mogi das Cruzes", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/mogi_das_cruzes.png", contact: "contato@iemogi.com.br", instagram: "@ie_mogi" }
  ],
  "Goiás": [
    { city: "Goiânia", image: "https://ieneagrama.com.br/wp-content/uploads/2026/01/goiania.png", contact: "contato@iegoiania.com.br", instagram: "@ie_goiania" }
  ]
};

export const eneaflixData = [
  {
    title: "A Teoria de Tudo",
    type: "Filme",
    enneagramType: "Tipo 5",
    description: "Padrão de recolhimento e acúmulo de conhecimento como mecanismo de segurança.",
    image: "https://via.placeholder.com/300x450/0a0a0a/ffffff?text=A+Teoria+de+Tudo"
  },
  {
    title: "Julie & Julia",
    type: "Filme",
    enneagramType: "Tipo 3",
    description: "O padrão de performance e construção de imagem como motor de realização.",
    image: "https://via.placeholder.com/300x450/0a0a0a/ffffff?text=Julie+%26+Julia"
  },
  {
    title: "O Lado Bom da Vida",
    type: "Filme",
    enneagramType: "Tipo 7",
    description: "O mecanismo de fuga da dor através da dispersão e do entusiasmo compulsivo.",
    image: "https://via.placeholder.com/300x450/0a0a0a/ffffff?text=O+Lado+Bom+da+Vida"
  },
  {
    title: "The Crown",
    type: "Série",
    enneagramType: "Tipo 1",
    description: "O padrão de rigidez moral e a pressão interna do perfeccionismo estrutural.",
    image: "https://via.placeholder.com/300x450/0a0a0a/ffffff?text=The+Crown"
  }
];

export const blogData = [
  {
    title: "Como o Eneagrama Pode Transformar Sua Carreira",
    excerpt: "Como o mapeamento comportamental do Eneagrama gera vantagem estratégica na carreira.",
    date: "15 Mar 2025",
    category: "Carreira",
    image: "https://via.placeholder.com/600x400/f9f9f9/0a0a0a?text=Carreira"
  },
  {
    title: "Os 9 Tipos de Personalidade Explicados",
    excerpt: "Os 9 padrões de funcionamento: estrutura, mecanismo de defesa e ponto cego de cada tipo.",
    date: "10 Mar 2025",
    category: "Eneagrama",
    image: "https://via.placeholder.com/600x400/f9f9f9/0a0a0a?text=9+Tipos"
  },
  {
    title: "Eneagrama nas Relações: Como Melhorar Sua Comunicação",
    excerpt: "Diagnóstico dos padrões relacionais: como cada tipo distorce, evita e filtra a comunicação.",
    date: "05 Mar 2025",
    category: "Relacionamentos",
    image: "https://via.placeholder.com/600x400/f9f9f9/0a0a0a?text=Relacoes"
  }
];

export const clientLogos = [
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-40-300x135.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-37-300x136.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-9-300x92.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-38-300x173.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-21-300x104.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-31-300x199.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-27-300x93.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-26-300x62.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-25-300x61.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-23-300x97.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-12-300x73.png",
  "https://ieneagrama.com.br/wp-content/uploads/2023/01/Logo-41-300x120.png"
];
